/* global newscorpau, Rampart, GeaLoader */
import loadjs from 'loadjs';
import setUserReady from '../../components/lazyloader/set-user-ready';
import { initPerformance, markPerformance, measurePerformance } from '../../components/lux/performance';
import setUserDataFromCookies from './set-user-data-from-cookies';

markPerformance('js-critical-init');
initPerformance();

const isVideoPrioritisation = newscorpau?.featureToggles?.is_video_resource_prioritisation_enabled;
const isDecoupleTadFromUtag = newscorpau?.featureToggles?.is_decouple_tad_from_utag_enabled;
const isDecoupleUtagFromRampart = newscorpau?.featureToggles?.is_decouple_utag_from_rampart_enabled;

if (isDecoupleTadFromUtag || isDecoupleUtagFromRampart) {
    setUserDataFromCookies();
    console.debug('[speedcurve] utag_data at time of criticaljs', JSON.parse(JSON.stringify(window.utag_data)));
}

window.loadjs = loadjs || {};
window.isLoadedIndiesJs = false;
loadjs([newscorpau.siteCSS]);

let utagLoading = false;

const loadUtag = (includeSyncJS = true) => {
    markPerformance('js-utag-init');
    console.debug('[speedcurve] Loading uTag with feature flags: isVideoPrioritisation', isVideoPrioritisation, 'utagLoading', utagLoading);
    utagLoading = true;
    const utagScripts = includeSyncJS
        ? [newscorpau.utagSyncJS, newscorpau.utagJS]
        : [newscorpau.utagJS];
    loadjs(utagScripts, () => {
        markPerformance('js-utag-end');
        measurePerformance('js-utag-duration', 'js-utag-init', 'js-utag-end');
        if (newscorpau && newscorpau.galleryJS) {
            loadjs(newscorpau.galleryJS);
        }
    });
};

if (isDecoupleTadFromUtag) {
    markPerformance('js-tad-init');

    loadjs([
        newscorpau.tadRuntime, newscorpau.tadMain
    ], () => {
        markPerformance('js-tad-end');
        measurePerformance('js-tad-duration', 'js-tad-init', 'js-tad-end');
        console.debug('[speedcurve] tad loaded', window.ads_api);
    });

    markPerformance('js-prebid-init');

    loadjs([
        newscorpau.prebidJS
    ], () => {
        markPerformance('js-prebid-end');
        measurePerformance('js-prebid-duration', 'js-prebid-init', 'js-prebid-end');
        console.debug('[speedcurve] prebid loaded', window.pbjs);
    });
} else if (isDecoupleUtagFromRampart) {
    console.debug('[speedcurve] Loading uTag with decouple_utag_from_rampart enabled');
    loadUtag();
}

// - Sites that use Google Extended Access
const gea = [
    'metro',
    'theaustralian'
];
// - Sites that use Onetap
const oneTap = [
    'theaustralian',
    'news'
];
const googleOptions = {};
if (gea.includes(newscorpau.site) || gea.includes(newscorpau.brand)) {
    googleOptions.gea = true;
}
if ((oneTap.includes(newscorpau.site) || oneTap.includes(newscorpau.brand))) {
    googleOptions.oneTap = true;
}

const newsDomains = ['news', 'checkout', 'kidspot', 'bodyandsoul', 'escape'];
const siteAlias = (newsDomains.indexOf(newscorpau.site) > -1) ? 'newscomau' : newscorpau.site;

// Don't need rampart if we disable Auth
// Turn off rampart for 404s
if (!newscorpau.disableAuth && newscorpau.pagetype !== 'page-not-found' && newscorpau.authProvider === 'rampart') {
    // Load Rampart first
    markPerformance('js-rampart-init');
    loadjs([newscorpau.rampartJS], {
        success: () => {
            const options = {
                site: siteAlias,
                google: googleOptions
            };

            // news.com.au & Kidspot require explicit Rampart callback/logout URIs
            if (['news', 'kidspot', 'bodyandsoul', 'escape'].includes(newscorpau.site) || ['news', 'kidspot', 'bodyandsoul', 'escape'].includes(newscorpau.brand)) {
                const env = newscorpau.environment !== 'prod' ? newscorpau.environment : '';
                options.callbackUri = `https://www.news${env}.com.au/remote/identity/auth/latest/login/callback.html`;
                options.logoutUri = `https://www.news${env}.com.au/remote/identity/auth/latest/logout/callback.html`;
            }

            newscorpau.rampart = new Rampart(options);
            newscorpau.rampart.getLoginStatus()
                .then(user => {
                    setUserReady(newscorpau, user);
                    markPerformance('js-rampart-end');
                    measurePerformance('js-rampart-duration', 'js-critical-init', 'js-rampart-end');

                    // CTS-2277 deferred account creation
                    if (newscorpau.extendedAccessJS) {
                        loadjs([newscorpau.extendedAccessJS], () => {
                            const geaLoader = new GeaLoader({ masthead: options.site, rampart: newscorpau.rampart, disableAnalytics: true });
                            geaLoader.linkAccountWithIdToken(user.id_token);
                        });
                    }
                })
                .catch(error => {
                    // Rampart by design rejects the promise with an error object for an
                    // anonymous user
                    if (error.status === 'not_authorised') {
                        setUserReady(newscorpau, {
                            memType: 'anonymous'
                        });
                        markPerformance('js-rampart-end');
                        measurePerformance('js-rampart-duration', 'js-critical-init', 'js-rampart-end');
                    }
                });


            if (!utagLoading) {
                loadUtag();
            }

            // C3PO JS Requires PSCID
            if (newscorpau && ((newscorpau.c3po && newscorpau.c3po.enabled) || (newscorpau.c3poWishlistFeature && newscorpau.c3poWishlistFeature.enabled))) {
                loadjs(newscorpau.c3poJS);
            }

            // Both metros and nca requires vidora SDK
            if (newscorpau && (newscorpau.brand === 'metro' || newscorpau.brand === 'news' || newscorpau.brand === 'codesports')) {
                loadjs(newscorpau.vidora);
            }
        },
        error: () => {
            if (!utagLoading) {
                // Try and load uTag even if rampart failed - uTagSync needs rampart, exclude them.
                loadUtag(false);
            }
            // Both metros and nca requires vidora SDK
            if (newscorpau && (newscorpau.brand === 'metro' || newscorpau.brand === 'news' || newscorpau.brand === 'codesports')) {
                loadjs(newscorpau.vidora);
            }
        }
    });
} else if (!utagLoading) {
    loadUtag(false);
}

if (!window.isLoadedIndiesJs) {
    window.isLoadedIndiesJs = true;
    loadjs(
        [newscorpau.indiesLoaderJS],
        {
            success: () => {
                newscorpau?.indiesLoader?.init?.();
            },
            error: () => {
                console.error('Indies script did not load');
            }
        }
    );
}

loadjs([newscorpau.siteJS]);

if (newscorpau && newscorpau.longformJS) {
    loadjs(newscorpau.longformJS);
}

if (newscorpau && newscorpau.gutenbergloaderJS) {
    loadjs(newscorpau.gutenbergloaderJS);
}

if (newscorpau && newscorpau.personalisation && newscorpau.personalisation.personalisationJS) {
    loadjs(newscorpau.personalisation.personalisationJS);
}

if (newscorpau && newscorpau.load_avp) {
    loadjs(newscorpau.avpHelperJS);
}

// Load Video JS if the video player is in the body
if (newscorpau.hasvideo) {
    markPerformance('js-oneplayer-init');
    loadjs([newscorpau.videoPlayerJS], {
        success: () => {
            markPerformance('js-oneplayer-end');
            measurePerformance('js-oneplayer-duration', 'js-oneplayer-init', 'js-oneplayer-end');
        }
    });
    // Get the logos for byline async and don't wait for the player JS
    loadjs(`/wp-content/themes/newscorpau-news-dna/dist/stylesheets/css-logos.css?${newscorpau.cache_key}=${newscorpau.cache_version_css}`);
}

// Load any 3rd party scripts like Twitter for article pages
// if (newscorpau.thirdPartyArticle) {
// loadjs(newscorpau.thirdPartyArticle);
// }

if (newscorpau && newscorpau.showLiveblogNca === 'true') {
    loadjs([newscorpau.newLiveblogCss, newscorpau.newLiveblogJs]);
}

if (newscorpau && newscorpau.liveblogThemeCss && newscorpau.liveblogCss && newscorpau.liveblogJs) {
    loadjs([newscorpau.liveblogThemeCss, newscorpau.liveblogCss, newscorpau.liveblogJs]);
}

if (newscorpau && newscorpau.liveblogEmbedLoader) {
    loadjs(newscorpau.liveblogEmbedLoader);
}

if (newscorpau && newscorpau.liveblogEmbedScripts) {
    loadjs(newscorpau.liveblogEmbedScripts);
}

if (newscorpau && newscorpau.videohubJS) {
    loadjs(newscorpau.videohubJS);
}

if (newscorpau && newscorpau.searchJS && !newscorpau.disableSearch) {
    loadjs(newscorpau.searchJS);
}

if (newscorpau && newscorpau.weatherResultJS) {
    loadjs(newscorpau.weatherResultJS);
}

if (newscorpau && newscorpau.podcast) {
    loadjs([newscorpau.podcast.css, newscorpau.podcast.js]);
}

if (newscorpau && newscorpau.hasAudio) {
    loadjs([newscorpau.audioPlayer.css, newscorpau.audioPlayer.js]);
}

if (newscorpau && newscorpau.staticVideoPlayer && newscorpau.staticVideoPlayer.playerJS) {
    loadjs([newscorpau.staticVideoPlayer.playerJS]);
}

if (newscorpau && newscorpau.mosaicHelperJS && newscorpau.requireMosaicHelper) {
    loadjs(newscorpau.mosaicHelperJS);
}

if (newscorpau && newscorpau.imageZoomJS) {
    loadjs(newscorpau.imageZoomJS);
}

if (newscorpau && newscorpau.outbrainJS && newscorpau.outbrainOnForSite) {
    loadjs(newscorpau.outbrainJS);
}

if (newscorpau && newscorpau.animationHelper) {
    loadjs(newscorpau.animationHelper);
}

if (newscorpau && newscorpau.ecommSearchHelper) {
    loadjs(newscorpau.ecommSearchHelper);
}

if (newscorpau && newscorpau.productCardTrackerJS) {
    loadjs(newscorpau.productCardTrackerJS);
}

if (newscorpau && newscorpau.trackonomicsReferrerHelperJS) {
    loadjs(newscorpau.trackonomicsReferrerHelperJS);
}

if (newscorpau && newscorpau.collapsibleSitemapJS) {
    loadjs(newscorpau.collapsibleSitemapJS);
}

if (newscorpau && newscorpau.foodRecipeJS) {
    loadjs(newscorpau.foodRecipeJS);
}

if (newscorpau && newscorpau.printBtnJS) {
    loadjs(newscorpau.printBtnJS);
}
